import * as React from 'react';
import NumberFormat from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const MaskedPhoneNumber = React.forwardRef<NumberFormat<string>, CustomProps>(
  function MaskedPhoneNumber(props, ref) {
    const { onChange, ...other } = props;
    return (
      <NumberFormat
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: '1' + values.value,
            },
          });
        }}
        format='1 (###) ###-####'
        isNumericString
      />
    );
  }
);

export default MaskedPhoneNumber;
